import React, { useState } from "react";
import { Trash2, ChevronsUpDown, Loader, X, Share2, SquarePen, Copy } from "lucide-react";
import { can_visit, handelCopyLink } from "../../helpers";
import MessageViewModal from "../Modal/MessageViewModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function PasswordManagerDataTable(props) {
  const {
    user_id,
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    buttonLoader = false,
    globalCheckedIds,
    setGlobalCheckedIds,
    setSelectedPasswordData = () => {},
    setPasswordEditData = () => {},
    setEditPassword = () => {},
    setPasswordDeletedId = null,
    setActiveDeleteModal = () => {},
    setActiveBulkDeleteModal = () => {},
    setPasswordSharedata = null,
    setOpenSharePasswordModal = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [passwordNote, setPasswordNote] = useState(null);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  const removeSelection = () => {
    setSelectedPasswordData([]);
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const visitURL = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  const handleNoteView = (details) => {
    setPasswordNote(details);
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
            {(can_visit('password_manager') && can_visit("password_manager_delete")) && (
              <>
                <button 
                  className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                  disabled = {buttonLoader ? true : false}
                  onClick = {() => {
                    setActiveBulkDeleteModal(true);
                    setPreviousScrollPosition(window.scrollY);
                    window.scrollTo(0, 0);
                  }}
                >
                  <Trash2 width={20} height={20} />
                  <span>Delete</span>
                  {buttonLoader && (
                    <span className="docpro_loading">
                      <Loader width={20} height={20} />
                    </span>
                  )}
                </button>
                {checkedIds?.length > 0 && (
                  <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                    <span><b>Selected Data</b>: {checkedIds?.length}</span>
                    <button
                      onClick={removeSelection}
                    >
                      <X width={18} height={18} />
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive docpro_toor_box3" style={{ minHeight: "300px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("title");
                }}
                className={orderBy === "tirle" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Title <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("username");
                  }}
                  className={
                    orderBy === "username" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    User Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th> Password </th>
              <th
                onClick={() => {
                  handleOrderChange("portal_url");
                }}
                className={orderBy === "portal_url" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  URL <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th> Note </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td>
                          {item?.accountName}
                        </td>
                        <td>
                          {item?.locationName}
                        </td>
                      </>
                    )}

                    <td>
                      {item?.title}
                    </td>
                    <td>
                      <div className="flex items-center">
                        <LimitText text={item?.username || ""} limit={15} />
                        <button 
                          type="button"
                          className="docpro_bordered_btn"
                          onClick={() => handelCopyLink(item?.username || "", "text")}
                          style={{ padding: '4px 6px', minWidth: '28px', minHeight: '28px', marginLeft: '10px' }}
                        >
                          <Copy width={15} height={15} />
                        </button>
                      </div>
                    </td>

                    <td>
                      <div className="flex items-center">
                        • • • • • • 
                        <button 
                          type="button"
                          className="docpro_bordered_btn"
                          onClick={() => handelCopyLink(item?.password  || "", "text")}
                          style={{ padding: '4px 6px', minWidth: '28px', minHeight: '28px', marginLeft: '10px' }}
                        >
                          <Copy width={15} height={15} />
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="flex items-center">
                        <div className="pointer" onClick={() => visitURL(item?.portal_url || "")}>
                          <LimitText text={item?.portal_url || ""} limit={20} />
                        </div>
                        <button 
                          type="button"
                          className="docpro_bordered_btn"
                          onClick={() => handelCopyLink(item?.portal_url || "")}
                          style={{ padding: '4px 6px', minWidth: '28px', minHeight: '28px', marginLeft: '10px' }}
                        >
                          <Copy width={15} height={15} />
                        </button>
                      </div>
                    </td>
                    <td>
                      <span 
                        className="docpro_badge docpro_badge_blue docpro_square docpro_fs_12 py-1 pointer"
                        onClick={() => handleNoteView(item?.note)}
                      >
                        View Note
                      </span>
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {(can_visit('password_manager') && can_visit("password_manager_create")) && (
                          <button type="button"
                            className="docpro_icon_btn"
                            onClick={() => {
                              setOpenSharePasswordModal(true);
                              setPasswordSharedata(item);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Share2 width={18} height={18} />
                            <span className="docpro_tip">Share</span>
                          </button>
                        )}
                        {(user_id === item?.created_by) && (
                          <button type="button"
                            className="docpro_icon_btn"
                            onClick={() => {
                              setEditPassword(true);
                              setPasswordEditData(item);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <SquarePen width={18} height={18} />
                            <span className="docpro_tip">Edit</span>
                          </button>
                        )}
                        {/* {(can_visit('password_manager') && can_visit("password_manager_delete")) && (
                          <button type="button"
                            className="docpro_icon_btn"
                            onClick={() => {
                              setPasswordDeletedId(item?.id);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash2 width={18} height={18} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )} */}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "300px" }} colSpan={`${can_visit("_role_enterprise") ? 9 : 7}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2.5 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageViewModal
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          message_body={passwordNote}
          segment={null}
          type={"note"}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
